const Theme = {
  headerRed: "#f7323f",
};

export default Theme;
